export default __webpack_public_path__ + "static/media/ogenius_inverse.8040bc28.svg";